"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(require("angular"));
var widget_count_warning_banner_html_1 = __importDefault(require("./widget-count-warning-banner.html"));
require("./widget-count-warning-banner.less");
var WidgetCountWarningBannerController = /** @class */ (function () {
    // @ts-ignore
    function WidgetCountWarningBannerController($filter) {
        this.$filter = $filter;
        this.$ctrl = this;
        this.translate = this.$filter('translate');
        var bannerText = this.translate('PR.LONGER_GENERATION_TIME_ALERT');
        angular.extend(this.$ctrl, {
            bannerText: bannerText
        });
    }
    WidgetCountWarningBannerController.$inject = [
        '$filter'
    ];
    return WidgetCountWarningBannerController;
}());
(function (angularModule) {
    angularModule.component('prWidgetCountWarningBanner', {
        templateUrl: widget_count_warning_banner_html_1.default,
        controller: WidgetCountWarningBannerController,
        require: {
            bodyCtrl: '^prBody'
        }
    });
})(angular.module('qualtrics.pr'));
